<template>
    <div ref="terminal"></div>
</template>
<script>
import { Terminal as XTerm } from 'xterm'
import LocalEchoController from 'local-echo'
import Vue from 'vue'
import 'xterm/dist/xterm.css'

export default {
    name: "Terminal",
    props: {
        bus: {
            type: Vue,
            required: true
        }
    },
    mounted () {
        let term = new XTerm()
        term.open(this.$refs.terminal)

        const localEcho = new LocalEchoController(term)

        this.bus.$on('writeOutput', payload => localEcho.print(payload))
        this.bus.$on('writeMessage', payload => localEcho.print(payload))
        this.bus.$on('read', prompt => localEcho.read(prompt || "> ").then(
            input => this.bus.$emit('input', input)
        ))
    }
}
</script>
